export enum PlanningDraftType {
  PICKUP_DROPOFF = 'PICKUP_DROPOFF',
  DISTRIBUTION = 'DISTRIBUTION'
}
